import script from "./TabStatusIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabStatusIcon.vue?vue&type=script&setup=true&lang=ts"

import "./TabStatusIcon.vue?vue&type=style&index=0&id=344c8633&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-344c8633"]])

export default __exports__